export const isRegistrationComplete = user => user?.registrationCompleted === true;
export const isProfileComplete = user => user?.profileCompleted === true;
export const hasStudentNavigation = user =>
    isProfileComplete(user) || isRegistrationComplete(user);
export const shouldShowProfileReminder = (user, dismissedThisSession = false) =>
    Boolean(user?._id) && user?.role === 'student' && !isProfileComplete(user) &&
    !user?.suppressProfileReminder && !dismissedThisSession;

export const getPostLoginDestination = (user, discoveryPath = '/discovery/countries') => {
    if (isRegistrationComplete(user) || user?.suppressRegistrationReminder) return discoveryPath;
    return isProfileComplete(user) ? '/register?magic=1&resume=1' : '/register?magic=1';
};
